import React from 'react';
import {getDeadEndNodes} from './traversal-algorithms/get-dead-end-nodes';
import {HiddenNodesActionsProps} from './interface';

interface Props extends HiddenNodesActionsProps {
    setHiddenNodesAndMovePositions: (newHiddenNodes: number[]) => void;
}

export function useHideNodes(props: Props) {
    const {hiddenNodes, selectedNodes, structuredGraph, setHiddenNodesAndMovePositions} = props;

    const hideNodesAndDeadEnds = React.useCallback(() => {
        const newHiddenNodes = new Set<number>([...hiddenNodes, ...selectedNodes]);
        selectedNodes.forEach((selectedNodeId) =>
            getDeadEndNodes(structuredGraph!, selectedNodeId).forEach((id) =>
                newHiddenNodes.add(id)
            )
        );

        setHiddenNodesAndMovePositions(Array.from(newHiddenNodes));
    }, [selectedNodes, hiddenNodes, setHiddenNodesAndMovePositions, structuredGraph]);

    const hideSelectedNodes = React.useCallback(() => {
        const newVal = Array.from(new Set<number>([...selectedNodes, ...hiddenNodes]));
        setHiddenNodesAndMovePositions(newVal);
    }, [selectedNodes, setHiddenNodesAndMovePositions, hiddenNodes]);

    const hideAllNodes = React.useCallback(() => {
        setHiddenNodesAndMovePositions(structuredGraph!.allNodes.map((node) => node.id));
    }, [setHiddenNodesAndMovePositions, structuredGraph]);

    return {
        hideNodesAndDeadEnds,
        hideSelectedNodes,
        hideAllNodes
    };
}
